import Axios from "axios";
import store from "./store/store";
import ErrorAlert from "./ErrorAlert";

export default {
  install(Vue) {
    const axios = Axios;

    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

    axios.defaults.baseURL =
      process.env.VUE_APP_FIREBASE_CLOUD_FUNCTIONS_ROOT_URL;

    axios.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${store.getters["auth/userToken"]}`;
      return config;
    });

    axios.interceptors.response.use(
      response => response,
      error => {
        if (
          !(
            error.config.hasOwnProperty("globalErrorHandler") &&
            error.config.globalErrorHandler === false
          )
        ) {
          ErrorAlert(error.message);
        }

        return Promise.reject(error);
      }
    );

    Vue.prototype.$http = axios;
  }
};
